import { User } from "@/types/users"
import { cn } from "@/lib/utils"
import AvatarBadge from "./AvatarBadge"
import { Position } from "@/app/(app)/(paragraph)/dashboard/components/CollectorAvatars/types"
import { AuthorAvatar } from ".."

export default function AvatarGroup({
  avatars,
  text,
  textClassName,
  className,
  small,
  position,
  variant,
  isNumbersOnly,
}: {
  avatars: Partial<User>[]
  text?: string
  textClassName?: string
  className?: string
  small?: boolean
  position?: Position
  variant?: "muted" | "minimal"
  isNumbersOnly?: boolean
}) {
  return (
    <>
      {!isNumbersOnly && (
        <div
          className={cn(
            "flex flex-row justify-center ",
            small ? "-space-x-1 hover:space-x-0" : "-space-x-3 hover:space-x-0",
            "*:ring *:ring-background",
            className
          )}
        >
          {avatars.map((avatar, i) => (
            <AuthorAvatar key={i} user={avatar} size={24} className="h-6 w-6" />
          ))}
        </div>
      )}
      {text && (
        <AvatarBadge
          text={text}
          textClassName={textClassName}
          small={small}
          position={position}
          variant={variant}
        />
      )}
    </>
  )
}
